module.exports = __webpack_public_path__ + "static/media/suit-hearts.c26d5f3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/suit-hearts.png
// module id = 135
// module chunks = 0